import EventTypeLink from 'domains/models/event_type_link';

import { z } from 'zod';

export type EventTypeLinkItem = z.infer<typeof schemaEventTypeLinkItem>;
export const schemaEventTypeLinkItem = z.object({
  instagramUrl: z.string().nullable(),
  lineUrl: z.string().nullable(),
  twitterUrl: z.string().nullable(),
  homepageUrl: z.string().nullable(),
  youtubeUrl: z.string().nullable(),
  facebookUrl: z.string().nullable(),
});

export type EventTypeLinkUpdateBody = z.infer<
  typeof schemaEventTypeLinkUpdateBody
>;
export const schemaEventTypeLinkUpdateBody = schemaEventTypeLinkItem.partial();

export const toItem = (
  eventTypeLink: EventTypeLink | null,
): EventTypeLinkItem => {
  if (eventTypeLink) {
    return {
      instagramUrl: eventTypeLink.instagramUrl,
      lineUrl: eventTypeLink.lineUrl,
      twitterUrl: eventTypeLink.twitterUrl,
      homepageUrl: eventTypeLink.homepageUrl,
      youtubeUrl: eventTypeLink.youtubeUrl,
      facebookUrl: eventTypeLink.facebookUrl,
    };
  } else {
    return {
      instagramUrl: null,
      lineUrl: null,
      twitterUrl: null,
      homepageUrl: null,
      youtubeUrl: null,
      facebookUrl: null,
    };
  }
};
